import { GET_STOCKTAKE_ENTRIES } from "../../types";

const initialState = {
    stocktakeEntriesData: [],
    isAgencyChnage:false,
    loading:false,
    errors:[]
}

export default function (state = initialState, action) {
	switch (action.type) {
		case GET_STOCKTAKE_ENTRIES:
			return {
                ...state,
                stocktakeEntriesData:action.payload,
                errors:[],
                isAgencyChnage:true
              }
        // case SET_ERRORS:
        //         return {
        //             ...state,
        //             errors:action.payload
        //           }
		default:
			return state;
	}
}
